import { render } from "./RouterTabs.vue?vue&type=template&id=010a3d5a"
import script from "./RouterTabs.vue?vue&type=script&lang=js"
export * from "./RouterTabs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__